import {FormMakerFormMode} from '@FormMakerReact/form-maker.types';

/** Icon + label-key pair for each form-toggler tab. */
export interface FormMakerFormTogglerView {
  readonly mode: FormMakerFormMode;
  readonly icon: string;
  readonly labelKey: string;
}

export const FORM_TOGGLER_VIEWS: readonly FormMakerFormTogglerView[] = [
  {mode: FormMakerFormMode.SIGNUP, icon: 'icon-align-left', labelKey: 'pmwjs_form_maker_form_toggler_signup'},
  {mode: FormMakerFormMode.CONFIRMATION, icon: 'icon-check-circle', labelKey: 'pmwjs_form_maker_form_toggler_confirmation'},
];
